import React from "react";
import { Card, CardBody } from "@heroui/react";
import PageTemplate from "../components/PageTemplate";

export default function Board() {
  const committees = [
    {
      title: "Directors",
      image: "/Board3.0/Directors.jpeg",
      members: [
        { name: "Adarsh Patel" },
        { name: "Khushmeet Vassan" },
        { name: "Himit Shah" }
      ],
      committeeEmail: "directors@njnaach.com"
    },
    {
      title: "Logistics",
      image: "/Board3.0/Logistics Committee Picture .jpg",
      members: [
        { name: "Ria Sharma" },
        { name: "Shatkratu Swarnkar" },
        { name: "Riddhi Gandhi" }
      ],
      committeeEmail: "logistics@njnaach.com"
    },
    {
      title: "Finance",
      image: "/Board3.0/Finance Chairs.jpg",
      members: [
        { name: "Nikhilesh Machan" },
        { name: "Ashna Karthik" }
      ],
      committeeEmail: "finance@njnaach.com"
    },
    {
      title: "Head Liaison",
      image: "/Board3.0/HeadLiaisons.jpeg",
      members: [
        { name: "Kriti Tyagi" },
        { name: "Netra Patel" },
        { name: "Maitri Bhupatkar" }
      ],
      committeeEmail: "headliaisons@njnaach.com"
    },
    {
      title: "Board Rep",
      image: "/Board3.0/Board Representatives.jpg",
      members: [
        { name: "Nayan Yadav" },
        { name: "Khushi Shah" },
        { name: "Kenz Mehaboob" }
      ],
      committeeEmail: "boardreps@njnaach.com"
    },
    {
      title: "Sponsorship",
      image: "/Board3.0/Sponsorship Chairs.jpg",
      members: [
        { name: "Vinit Shenoy" },
        { name: "Nisarg Mehta" }
      ],
      committeeEmail: "sponsorship@njnaach.com"
    },
    {
      title: "Tech",
      image: "/Board3.0/Tech.JPG",
      members: [
        { name: "Sahil Mittal" },
        { name: "Kavya Jain" }
      ],
      committeeEmail: "tech@njnaach.com"
    },
    {
      title: "Registration",
      image: "/Board3.0/Registration Chairs.jpeg",
      members: [
        { name: "Prithvi Sunkavelli" },
        { name: "Purva Unhale" }
      ],
      committeeEmail: "registration@njnaach.com"
    },
    {
      title: "Philanthropy",
      image: "/Board3.0/Philanthropy Chair.jpg",
      members: [
        { name: "Siya Deshmukh" }
      ],
      committeeEmail: "philanthropy@njnaach.com"
    },
    {
      title: "Hospitality",
      image: "/Board3.0/Hosp.jpg",
      members: [
        { name: "Anvi Pofale" },
        { name: "Chandni Shah" },
        { name: "Preya Patel" }
      ],
      committeeEmail: "hospitality@njnaach.com"
    },
    {
      title: "Public Relations",
      image: "/Board3.0/PR chairs.jpg",
      members: [
        { name: "Sanskriti Ramji" },
        { name: "Sana Raza" },
        { name: "Disha Patel" }
      ],
      committeeEmail: "publicrelations@njnaach.com"
    },
    {
      title: "Social",
      image: "/Board3.0/Social Chairs.jpeg",
      members: [
        { name: "Diya Kumar" },
        { name: "Laksh Panchal" },
        { name: "Sahaana Shastri" }
      ],
      committeeEmail: "social@njnaach.com"
    },
    {
      title: "Judging",
      image: "/Board3.0/Judging Chairs.jpeg",
      members: [
        { name: "Nishi Patel" },
        { name: "Sancharitha Ramji" }
      ],
      committeeEmail: "judging@njnaach.com"
    },
    {
      title: "Freshmen Rep",
      image: "/Board3.0/Freshmen Representative Board.jpg",
      members: [
        { name: "Rohan Shah" },
        { name: "Mehakjot Kaur" }
      ],
      committeeEmail: null // No email provided for this committee
    },
    {
      title: "Senior Advisors",
      image: "/Board3.0/Senior Advisors.JPG_",
      members: [
        { name: "Meghna Prakash" },
        { name: "Jasmine Patel" }
      ],
      committeeEmail: "senioradvisors@njnaach.com"
    }
  ];

  return (
    <PageTemplate>
      {/* Hero Section */}
      <div className="bg-gradient-to-br from-pink-100 via-coral-100 to-cream-100 py-8 sm:py-12 lg:py-16 px-4 sm:px-6 relative overflow-hidden">
        <div className="max-w-6xl mx-auto text-center relative z-10">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-text font-bold text-coral mb-4 sm:mb-6 animate-fade-in">
            Executive Board
          </h1>
          <div className="w-16 sm:w-20 lg:w-24 h-1 bg-coral mx-auto rounded-full"></div>
        </div>
      </div>

      {/* Committee Grid */}
      <div className="py-12 sm:py-16 lg:py-20 px-4 sm:px-6 bg-cream-50">
        <div className="max-w-7xl mx-auto">
          {/* Row 1: Directors (1 committee, centered, larger) */}
          <div className="flex justify-center mb-16 sm:mb-20 lg:mb-24 mt-8 sm:mt-12 lg:mt-16">
            <Card 
              className="w-96 h-96 sm:w-[36rem] sm:h-[28rem] lg:w-[48rem] lg:h-[28rem] bg-white/80 backdrop-blur-sm border border-peach-200 shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300 animate-fade-in overflow-hidden"
            >
              {/* Committee Picture */}
              <div className="relative h-[85%] overflow-hidden">
                <img 
                  src={committees[0].image} 
                  alt={committees[0].title}
                  className="w-full h-full object-cover"
                  style={{ objectPosition: 'center 65%' }}
                />
              </div>
              
              <CardBody className="h-[15%] p-2 text-center flex flex-col justify-center overflow-hidden">
                  {/* Committee Title */}
                  <h3 className="text-sm sm:text-base lg:text-lg font-text font-bold text-coral mb-1">
                    {committees[0].title}
                  </h3>
                  {/* Member Names */}
                  <p className="text-teal-600 font-text text-xs sm:text-sm line-clamp-1">
                  {committees[0].members.map((member, memberIndex) => {
                    const nameWithNonBreakingSpaces = member.name.replace(/ /g, '\u00A0');
                    return (
                      <span key={memberIndex}>
                        {nameWithNonBreakingSpaces}
                        {memberIndex < committees[0].members.length - 1 && <span>, </span>}
                      </span>
                    );
                  })}
                </p>
              </CardBody>
            </Card>
          </div>

          {/* Row 2: Logistics, Finance, Head Liaison (3 committees) */}
          <div className="flex justify-center space-x-8 sm:space-x-12 lg:space-x-16 mb-16 sm:mb-20 lg:mb-24">
            {committees.slice(1, 4).map((committee, index) => (
              <Card 
                key={index}
                className="w-80 h-80 sm:w-96 sm:h-96 lg:w-96 lg:h-96 bg-white/80 backdrop-blur-sm border border-peach-200 shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300 animate-fade-in overflow-hidden"
                style={{ animationDelay: `${(index + 1) * 0.1}s` }}
              >
                {/* Committee Picture */}
                <div className="relative h-[75%] overflow-hidden">
                  <img 
                    src={committee.image} 
                    alt={committee.title}
                    className="w-full h-full object-cover"
                    style={committee.title === "Logistics" ? { transform: 'scale(1.3)', objectPosition: 'center 80%' } : {}}
                  />
                </div>
                
                <CardBody className="h-[25%] p-2 text-center flex flex-col justify-center overflow-hidden">
                  {/* Committee Title */}
                  <h3 className="text-sm sm:text-base lg:text-lg font-text font-bold text-coral mb-1">
                    {committee.title}
                  </h3>
                  {/* Member Names */}
                  <p className="text-teal-600 font-text text-xs sm:text-sm line-clamp-1">
                    {committee.members.map((member, memberIndex) => {
                      const nameWithNonBreakingSpaces = member.name.replace(/ /g, '\u00A0');
                      return (
                        <span key={memberIndex}>
                          {nameWithNonBreakingSpaces}
                          {memberIndex < committee.members.length - 1 && <span>, </span>}
                        </span>
                      );
                    })}
                  </p>
                </CardBody>
              </Card>
            ))}
          </div>

          {/* Row 3: Board Rep, Sponsorship, Tech (3 committees) */}
          <div className="flex justify-center space-x-8 sm:space-x-12 lg:space-x-16 mb-16 sm:mb-20 lg:mb-24">
            {committees.slice(4, 7).map((committee, index) => (
              <Card 
                key={index}
                className="w-80 h-80 sm:w-96 sm:h-96 lg:w-96 lg:h-96 bg-white/80 backdrop-blur-sm border border-peach-200 shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300 animate-fade-in overflow-hidden"
                style={{ animationDelay: `${(index + 4) * 0.1}s` }}
              >
                {/* Committee Picture */}
                <div className="relative h-[75%] overflow-hidden">
                  <img 
                    src={committee.image} 
                    alt={committee.title}
                    className="w-full h-full object-cover"
                    style={
                      committee.title === "Board Rep" ? { objectPosition: 'center 80%' } :
                      committee.title === "Tech" ? {transform: 'scale(1.3)', objectPosition: 'center 90%' } :
                      committee.title === "Sponsorship" ? { transform: 'scale(1.8)', objectPosition: 'center 80%' } : {}
                    }
                  />
                </div>
                
                <CardBody className="h-[25%] p-2 text-center flex flex-col justify-center overflow-hidden">
                  {/* Committee Title */}
                  <h3 className="text-sm sm:text-base lg:text-lg font-text font-bold text-coral mb-1">
                    {committee.title}
                  </h3>
                  {/* Member Names */}
                  <p className="text-teal-600 font-text text-xs sm:text-sm line-clamp-1">
                    {committee.members.map((member, memberIndex) => {
                      const nameWithNonBreakingSpaces = member.name.replace(/ /g, '\u00A0');
                      return (
                        <span key={memberIndex}>
                          {nameWithNonBreakingSpaces}
                          {memberIndex < committee.members.length - 1 && <span>, </span>}
                        </span>
                      );
                    })}
                  </p>
                </CardBody>
              </Card>
            ))}
          </div>

          {/* Row 4: Registration, Philanthropy, Hospitality (3 committees) */}
          <div className="flex justify-center space-x-8 sm:space-x-12 lg:space-x-16 mb-16 sm:mb-20 lg:mb-24">
            {committees.slice(7, 10).map((committee, index) => (
              <Card 
                key={index}
                className="w-80 h-80 sm:w-96 sm:h-96 lg:w-96 lg:h-96 bg-white/80 backdrop-blur-sm border border-peach-200 shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300 animate-fade-in overflow-hidden"
                style={{ animationDelay: `${(index + 7) * 0.1}s` }}
              >
                {/* Committee Picture */}
                <div className="relative h-[75%] overflow-hidden">
                  <img 
                    src={committee.image} 
                    alt={committee.title}
                    className="w-full h-full object-cover"
                    style={
                      committee.title === "Registration" ? { transform: 'scale(1.3)', transformOrigin: 'center 30%' } :
                      committee.title === "Philanthropy" ? { transform: 'scale(1.3)', objectPosition: 'center 80%' } :
                      committee.title === "Hospitality" ? { objectPosition: 'center 80%' } : {}
                    }
                  />
                </div>
                
                <CardBody className="h-[25%] p-2 text-center flex flex-col justify-center overflow-hidden">
                  {/* Committee Title */}
                  <h3 className="text-sm sm:text-base lg:text-lg font-text font-bold text-coral mb-1">
                    {committee.title}
                  </h3>
                  {/* Member Names */}
                  <p className="text-teal-600 font-text text-xs sm:text-sm line-clamp-1">
                    {committee.members.map((member, memberIndex) => {
                      const nameWithNonBreakingSpaces = member.name.replace(/ /g, '\u00A0');
                      return (
                        <span key={memberIndex}>
                          {nameWithNonBreakingSpaces}
                          {memberIndex < committee.members.length - 1 && <span>, </span>}
                        </span>
                      );
                    })}
                  </p>
                </CardBody>
              </Card>
            ))}
          </div>

          {/* Row 5: Public Relations, Social, Judging (3 committees) */}
          <div className="flex justify-center space-x-8 sm:space-x-12 lg:space-x-16 mb-16 sm:mb-20 lg:mb-24">
            {committees.slice(10, 13).map((committee, index) => (
              <Card 
                key={index}
                className="w-80 h-80 sm:w-96 sm:h-96 lg:w-96 lg:h-96 bg-white/80 backdrop-blur-sm border border-peach-200 shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300 animate-fade-in overflow-hidden"
                style={{ animationDelay: `${(index + 10) * 0.1}s` }}
              >
                {/* Committee Picture */}
                <div className="relative h-[75%] overflow-hidden">
                  <img 
                    src={committee.image} 
                    alt={committee.title}
                    className="w-full h-full object-cover"
                    style={
                      committee.title === "Public Relations" ? { objectPosition: 'center 75%' } :
                      committee.title === "Social" ? { transform: 'scale(1.4)' } :
                      committee.title === "Judging" ? { objectPosition: 'center 85%' } : {}
                    }
                  />
                </div>
                
                <CardBody className="h-[25%] p-2 text-center flex flex-col justify-center overflow-hidden">
                  {/* Committee Title */}
                  <h3 className="text-sm sm:text-base lg:text-lg font-text font-bold text-coral mb-1">
                    {committee.title}
                  </h3>
                  {/* Member Names */}
                  <p className="text-teal-600 font-text text-xs sm:text-sm line-clamp-1">
                    {committee.members.map((member, memberIndex) => {
                      const nameWithNonBreakingSpaces = member.name.replace(/ /g, '\u00A0');
                      return (
                        <span key={memberIndex}>
                          {nameWithNonBreakingSpaces}
                          {memberIndex < committee.members.length - 1 && <span>, </span>}
                        </span>
                      );
                    })}
                  </p>
                </CardBody>
              </Card>
            ))}
          </div>

          {/* Row 6: Freshmen Rep, Senior Advisors (2 committees) */}
          <div className="flex justify-center space-x-8 sm:space-x-12 lg:space-x-16 mb-16 sm:mb-20 lg:mb-24">
            {committees.slice(13, 15).map((committee, index) => (
              <Card 
                key={index}
                className="w-80 h-80 sm:w-96 sm:h-96 lg:w-96 lg:h-96 bg-white/80 backdrop-blur-sm border border-peach-200 shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300 animate-fade-in overflow-hidden"
                style={{ animationDelay: `${(index + 13) * 0.1}s` }}
              >
                {/* Committee Picture */}
                <div className="relative h-[75%] overflow-hidden">
                  <img 
                    src={committee.image} 
                    alt={committee.title}
                    className="w-full h-full object-cover"
                    style={committee.title === "Senior Advisors" ? { transform: 'scale(1.3)' } : {}}
                  />
                </div>
                
                <CardBody className="h-[25%] p-2 text-center flex flex-col justify-center overflow-hidden">
                  {/* Committee Title */}
                  <h3 className="text-sm sm:text-base lg:text-lg font-text font-bold text-coral mb-1">
                    {committee.title}
                  </h3>
                  {/* Member Names */}
                  <p className="text-teal-600 font-text text-xs sm:text-sm line-clamp-1">
                    {committee.members.map((member, memberIndex) => {
                      const nameWithNonBreakingSpaces = member.name.replace(/ /g, '\u00A0');
                      return (
                        <span key={memberIndex}>
                          {nameWithNonBreakingSpaces}
                          {memberIndex < committee.members.length - 1 && <span>, </span>}
                        </span>
                      );
                    })}
                  </p>
                </CardBody>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </PageTemplate>
  );
} 